















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'create-form',
  components: {
  },
  model: {
    prop: 'dialogVisible',
    event: 'update',
  },
})
export default class Products extends Vue {
  @Prop({ default: false }) public dialogVisible!: boolean;

  private form = {
    name: '',
  }

  private handleFormSubmit() {
    this.$emit('submit', this.form);
  }

  private onTriggerClose() {
    this.$emit('update', false);
  }
}
